import { useEffect } from 'react'
import { useThrottledCallback } from 'use-debounce'

import { useJourneyContext } from '../blocks-renderers/providers/JourneyContext'
import { syncStepsState } from '../store/actions/syncBlockState'

/**
 * Responsible for syncing state from Journey context to the Store.
 *
 * @deprecated to be removed when state management is fully migrated to the store
 */
export const useSyncAppStore = () => {
  const { context } = useJourneyContext()

  const throttledSyncStepsState = useThrottledCallback(syncStepsState, 50, {
    leading: false,
    trailing: true
  })

  useEffect(
    // sync step state changes to the store
    () =>
      void throttledSyncStepsState({ stepsState: context._stepsStateArray }),
    [throttledSyncStepsState, context._stepsStateArray]
  )
}
